const Footer = () => {
    return(
        <footer>
            <p>@{new Date().getFullYear()} MERN Market</p>
        </footer>
    )
}
export default Footer